import React from "react";
import Arrow from "./icons/Arrow.jsx";
import COMPANY from "../data/company.js";

const CtaBand = ({ go }) => (
  <section className="sec">
    <div className="wrap">
      <div className="cta-band reveal">
        <span className="eyebrow" style={{ color: "#A9B2F6" }}>Request a quotation</span>
        <h2 className="h-lg">Tell us what needs moving.</h2>
        <p>Send us the collection point, the destination and the deadline. You will have a costed
          transport plan back from a real person, usually the same working day.</p>
        <div className="cta-row">
          <button className="btn btn-light" onClick={() => go("contact")}>Request a quote <Arrow /></button>
          <a className="btn btn-outline-light" href={COMPANY.phoneHref}>Call {COMPANY.phone}</a>
        </div>
      </div>
    </div>
  </section>
);

export default CtaBand;
